import { Box, Grid, Typography } from "@mui/material";
import { IndentDivider } from "Components/IndentDivider/IndentDivider";
import { DataConnectorsList, WebhooksList } from "features/dataConnectors";
import ProjectCodeSnippet from "features/project/components/ProjectCodeSnippet";
import { useSelectedProject } from "Hooks/useSelectedProject";

function DataConnectionsPage() {
  const { selectedProject } = useSelectedProject();
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="subtitle1">Incendium Tracking Code</Typography>
          <Typography variant="body1" mb={2} lineHeight={1.2}>
            Copy and paste this code snippet into the <code>&lt;head&gt;</code>{" "}
            of your website if you are not using one of our integrations.
          </Typography>
          <Box sx={{ maxWidth: 900 }}>
            <ProjectCodeSnippet project={selectedProject!} />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <IndentDivider />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1">Platforms</Typography>
          <Typography variant="body1" mb={2} lineHeight={1.2}>
            Connect to ad platforms you’re running ads in.
          </Typography>
          <Box>
            <DataConnectorsList type="platform" />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <IndentDivider />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1">Apps</Typography>
          <Typography variant="body1" mb={2} lineHeight={1.2}>
            Connect to these apps and install automatically for seamless
            integration.
          </Typography>
          <Box>
            <DataConnectorsList type="app" />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <IndentDivider />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1">Webhooks</Typography>
          <Typography variant="body1" mb={2} lineHeight={1.2}>
            Activate these webhooks and copy the URL to track sales data.
          </Typography>
          <Box>
            <WebhooksList />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default DataConnectionsPage;
